import React from 'react'
import { Button, csx, useToast } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { useHistory } from 'react-router'
import { newOrder as newOrderAction } from '@/checkout-instore-legacy/utils/SidebarUtils'

import type { DrawerProps } from '../../../../../../ui/components'
import { Drawer } from '../../../../../../ui/components'
import { useCheckout } from '../../../../state'
import { Icon } from '../../../../../../ui/components/Icon'
import { WarningIcon } from './WarningIcon'
import { getNewSaleRoute } from '../../../../../../utils/getNewSaleRoute'
import { useFeatureFlag, useInitialPath } from '../../../../../../core/hooks'
import { useOrderForm } from '../../../../../../core/requests/checkout'

export type ExitCartDrawerProps = DrawerProps

export const ExitCartDrawer = (props: ExitCartDrawerProps) => {
  const history = useHistory()
  const checkout = useCheckout()
  const initialPath = useInitialPath()
  const { isNewSaleCartRedirectEnabled } = useFeatureFlag()
  const { formatMessage } = useIntl()
  const { orderForm } = useOrderForm()
  const showToast = useToast()

  const newSaleRoute = getNewSaleRoute(
    initialPath,
    isNewSaleCartRedirectEnabled()
  )

  const handleBackCartButtonClick = () => {
    history.push('/cart')
  }

  const handleExitSaleButtonClick = () => {
    if (orderForm?.items.length) {
      showToast({
        message: formatMessage({
          id: 'checkout.toast.new-sale',
        }),
        action: {
          label: formatMessage({
            id: 'checkout.toast.new-sale.go-now',
          }),
          onClick: () => {
            history.push('/orders')
          },
        },
      })
    }

    checkout.clearMessages()
    newOrderAction()

    history.push(newSaleRoute)
  }

  const handleDrawerClose = () => {
    props.onClose()
  }

  return (
    <Drawer {...props} onClose={handleDrawerClose}>
      <div
        className={csx({
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        })}
      >
        <Icon
          className={csx({
            width: '3.125rem',
            height: '3.125rem',
            justifyContent: 'center',
          })}
        >
          <WarningIcon />
        </Icon>
        <p
          className={csx({
            display: 'block',
            fontSize: '1rem',
            marginY: '$space-5',
            fontWeight: '500',
            '@desktop': {
              fontSize: '1.25rem',
            },
          })}
        >
          <FormattedMessage id="checkout.order-summary.exit-cart-drawer.title" />
        </p>
        <p
          className={csx({
            fontSize: '0.875rem',
            marginTop: '$space-4',
            maxWidth: '230px',
            marginX: 'auto',
          })}
        >
          <FormattedMessage id="checkout.order-summary.exit-cart-drawer.message" />
        </p>
        <Button
          size="large"
          data-testid="go-to-cart"
          className={csx({ width: '100%', marginTop: '$space-6' })}
          onClick={handleBackCartButtonClick}
        >
          <FormattedMessage id="checkout.order-summary.exit-cart-drawer.primary-action" />
        </Button>
        <Button
          size="large"
          data-testid="start-sale"
          variant="criticalTertiary"
          className={csx({ width: '100%', marginTop: '$space-3' })}
          onClick={handleExitSaleButtonClick}
        >
          <FormattedMessage id="checkout.order-summary.exit-cart-drawer.secondary-action" />
        </Button>
      </div>
    </Drawer>
  )
}
